import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { GetPurchaseOrder, Getstates } from '../../../redux/actions/HttpRequest';
import { Col, Row } from 'reactstrap';
import TableGrid from '../../../components/tableGrid/TableGrid'
import SideFilter from '../../../components/sideFilter/SideFilter'
import consts from '../../../util/Consts';
import utils from '../../../util/Util';
import LoadingDialog from '../../../components/loadingDialog/LoadingDialog';
import PopupDialog from '../../../components/popupDialog/PopupDialog';
import api from '../../../redux/httpUtil/ServerApi';
import { instance } from '../../../redux/actions/Index';

class PurchaseList extends PureComponent {

    Columns = [
        { name: 'PO#', key: 'poNumber', sort: true, width: "50px" },
        { name: 'Name', key: 'name', sort: true, width: "180px" },
        { name: 'Address', key: 'address', sort: true, width: "210px" },
        { name: 'City', key: 'city', sort: true, width: "140px" },
        { name: 'State', key: 'state', sort: true, width: "50px" },
        { name: 'Zip', key: 'zip', sort: true, width: "50px" },
        { name: 'Phone', key: 'phone', sort: true, width: "92px" },
        { name: 'Cert#', key: 'certificate', sort: true, width: "82px" },
        { name: 'Invoice#', key: 'invoiceNumber', sort: true, width: "100px" },
        { name: 'Store#', key: 'locStore', sort: false, width: "50px" },
        { name: 'Claim#', key: 'claimNumber', sort: true, width: "82px" },
        { name: 'Status', key: 'status', sort: true, width: "105px" }
    ]

    constructor(props) {
        super(props);
        const isSessionEmpty = sessionStorage.length;
        if (isSessionEmpty === 0) {
            this.props.history.replace("/");
        }
        this.state = {
            showSideFilter: false,
            Data: [],
            pageSize: "10",
            pageNo: 1,
            userData: JSON.parse(sessionStorage.getItem(consts.sessionVariables.UserData)),
            isFetching: true,
            count: 0,
            totalRecords: 0,
            sideFiltervValues: JSON.parse(sessionStorage.getItem(consts.sessionVariables.POSideFilterData)),
            searchText: '',
            statesList: [],
            sortDir: 'desc',
            sortColumn: 'poNumber',
            FileType: ''
        }

        this.GetPurchaseOrder();

        this.props.dispatch(Getstates.request({}, '', "GET"));
    }

    setSideFilterHeight = () => {
        let height = this.divElement?.clientHeight;
        if (height < 600) height = 600;
        this.setState({ windowHeight: (height + 98) + 'px' });
    }

    handleModal = () => {
        let showModal = this.state.showModal
        this.setState({ showModal: !showModal, PopupEmail: false });
        if (showModal && this.timeout) clearInterval(this.timeout);
    }

    componentWillReceiveProps(nextProps) {
        
        // let me = this;
        if (nextProps.GetPurchaseOrder && nextProps.GetPurchaseOrder.data && nextProps.GetPurchaseOrder.data !== this.props.GetPurchaseOrder.data) {
            const { data } = nextProps.GetPurchaseOrder.data;
            
            let Data = data ? data.purchaseOrderModels : [];
            let totalRecords = data ? data.totalRecords : 0;
            this.setState({
                Data: Data, originalData: Data, isFetching: false, totalRecords:
                    totalRecords, resetPagination: this.state.isReset ? true : false
            }, () => {
                this.setSideFilterHeight();
                this.setState({ resetPagination: false, isReset: false });
            });
        }

        if (nextProps.Getstates && nextProps.Getstates.data && nextProps.Getstates.data !== this.props.Getstates.data) {
            const { data } = nextProps.Getstates.data;
            this.setState({ statesList: data });
        }
    }

    popupSubmit = email => {
        this.setState({ showModal: false, usingEmail: true, PopupEmail: false  });
        clearInterval(this.timeout);
        this.handleExport(this.state.FileType, email);
    }

    getRequest() {
        const { userData, pageSize, pageNo, sideFiltervValues, searchText, sortDir, sortColumn, totalRecords } = this.state;

        this.setState({ isFetching: true });

        let serachList = [];

        if (sideFiltervValues) {
            Object.keys(sideFiltervValues).map(key => {
                if (sideFiltervValues[key]) {
                    let obj = {
                        searchKey: consts.PoSideFilterMapping[key],
                        searchValue: sideFiltervValues[key]
                    }
                    serachList.push(obj)
                }
            });
        }

        return {
            sortColumn: consts.PoSideFilterMapping[sortColumn], searchText: searchText, sortDir: sortDir, pageNumber: pageNo.toString(), noofRecords: pageSize, iServicer: userData ? userData.userId : 0, serachList: serachList, count: totalRecords
        };
    }

    handleExport = (FileType, email) => {
        this.setState({ FileType: FileType }, () => {
            let req = this.getRequest();
            req.FileType = FileType;
            req.noofRecords = "-1";
            if (email) {
                req.email = email;
                this.setState({ isFetching: false });
            }

                instance.post(`${api.Export}`, req)
                  .then(res => {
                    console.log(res);
                    let { data, success, message } = res.data;

                    if (success && data) {
                        if(!this.state.usingEmail)  utils.downloadFile(data, this.state.FileType, 'POList_');
                        else   this.setState({ usingEmail: false });
                        
                        this.setState({ FileType: '' });
                    }
                    else if(success && message){
                        this.setState({ showModal: true, popupMessage: message, popupTitle: false, PopupEmail: false }, () => {
                            this.timeout = setTimeout(() => {
                                this.setState({ showModal: false });
                            }, 300000) // 5 min
                        });
                    }
                    else if (!success && !data && message === window.MailMsg) {        
                        this.setState({ showModal: true, popupMessage: message, popupTitle: false, PopupEmail: true }, () => {
                            this.timeout = setTimeout(() => {
                                this.setState({ showModal: false });
                            }, 300000) // 5 min
                        });
                    }
                    this.setState({ isFetching: false });
                  }).catch(err => {
                    this.setState({ isFetching: false });
                    console.log(err);
                  })
            
              
        });
    }

    GetPurchaseOrder = () => {
        let req = this.getRequest();
        this.props.dispatch(GetPurchaseOrder.request(req));
    }

    showHideSideFilter = val => {
        this.setState({ showSideFilter: val });
    }

    onRowClick = (details) => {
        sessionStorage.setItem(consts.sessionVariables.PurchaseOrderNumber, details.poNumber);
        sessionStorage.setItem(consts.sessionVariables.CertNumber, details.certificate);
        this.props.history.push("/PurchaseOrderDetails");
    }

    handleSorting = (sortDir, sortColumn) => {
        this.setState({ sortDir: sortDir, sortColumn: sortColumn, isFetching: true }, () => this.GetPurchaseOrder());
    }

    handlePageSize = (pageSize, activePageNo) => {
        let noOfRecords = pageSize === "All" ? "-1" : pageSize;
        this.setState({ pageSize: noOfRecords, pageNo: activePageNo, isFetching: true }, () => this.GetPurchaseOrder());
    }
    handlePageNo = pageNo => {
        this.setState({ pageNo: pageNo, isFetching: true }, () => this.GetPurchaseOrder());
    }

    handleSearch = e => {
        let me = this;
        let searchText = e.target.value;

        if (me.timeout) clearTimeout(me.timeout);
        me.timeout = setTimeout(() => {
            me.setState({ searchText: searchText }, () => {
                this.GetPurchaseOrder();
            });
        }, 1000);
    }

    onSubmitFilter = (values, isChanged) => {
        if(isChanged){
            this.setState({ sideFiltervValues: values, isFetching: true, isReset: true, pageNo: 1 }, () => this.GetPurchaseOrder());
        }else{
            this.setState({ isFetching: false, showModal: true, popupMessage: window.NoSelectionSideFilterMsg, popupTitle: false, PopupEmail: false }, () => {
                this.timeout = setTimeout(() => {
                    this.setState({ showModal: false });
                }, 300000) // 5 min
            });
        }
    }

    render() {
        let { showSideFilter, sideFiltervValues, windowHeight, Data, isFetching, totalRecords, resetPagination, statesList, sortDir, sortColumn, popupTitle, popupMessage, showModal, PopupEmail } = this.state;

        return (
            <div >
                <LoadingDialog isOpen={isFetching}></LoadingDialog>
                <Row className="justify-content-center">
                    {showSideFilter ? <Col className="p-0" md="3" lg="3">
                        <SideFilter
                            onSubmitFilter={(val, isChanged) => this.onSubmitFilter(val, isChanged)}
                            sideFiltervValues={sideFiltervValues}
                            screen="PurchaseOrders"
                            windowHeight={windowHeight}
                            statesList={statesList}
                        ></SideFilter>
                    </Col> : null}
                    <Col className="p-0" md={showSideFilter ? 9 : 12} lg={showSideFilter ? 9 : 12}>
                        <section ref={(divElement) => { this.divElement = divElement }} id="claims-section" className="claims-section pt-3">
                            <TableGrid
                                screenName="PURCHASE ORDERS"
                                Data={Data}
                                Columns={this.Columns}
                                showHideSideFilter={(val) => this.showHideSideFilter(val)}
                                headerFooter={true}
                                search={true}
                                pagination={true}
                                totalRecords={totalRecords}
                                onRowClick={(e) => this.onRowClick(e)}
                                tableClassName="table-web"
                                handlePageNo={this.handlePageNo}
                                handlePageSize={this.handlePageSize}
                                handleSearch={this.handleSearch}
                                resetPagination={resetPagination}
                                sortDir={sortDir}
                                sortColumn={sortColumn}
                                handleSorting={this.handleSorting}
                                handleExport={this.handleExport}
                            ></TableGrid>
                        </section>
                    </Col>
                </Row>

                {showModal ? <PopupDialog
                    showModal={showModal}
                    handleModal={this.handleModal}
                    title={popupTitle}
                    message={popupMessage}
                    email={PopupEmail}
                    popupSubmit={(val) => this.popupSubmit(val)}
                /> : ''}
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        GetPurchaseOrder: state.GetPurchaseOrder,
        Getstates: state.Getstates,
        Export: state.Export
    };
}

var PurchaseListModule = connect(mapStateToProps)(PurchaseList);
export default PurchaseListModule;